module.exports = __webpack_public_path__ + "img/311-icon.96c6df9d.svg";